import React from 'react';

//Forms
import Credenciais from '../components/Credenciais';

//Components
import Body from '../../../components/layoutcredenciamento/Body';
import Footer from '../../../components/layoutcredenciamento/Footer';
import Layout from '../../../components/layoutcredenciamento/Layout';

const Terminais  = () => {
    
    return (
        <Layout>
            <Body>
                <Credenciais />
            </Body>
        </Layout>
    );
}

export default Terminais;